<template>
  <div v-if="needButton" :class="['buttons', buttonPositionClass]">
    <Button
      v-if="cancelShow"
      :class="cancelClass"
      :loading="cancelLoading"
      :disabled="cancelDisabled"
      @click="onCancel"
    >
      {{cancelText}}
    </Button>
    <Button
      v-if="okShow"
      :class="[okClass, { 'margin-left-20': buttonPosition === 'right' }]"
      :loading="okLoading"
      :disabled="okDisabled"
      @click="onOk"
    >
      {{okText}}
    </Button>
  </div>
</template>

<script>
/**
 * modal button 样式
 * 部分 modal body 按钮部分可使用
 * button 已添加布局样式，只需添加按钮样式。即: btn-fill-34, width-100 等
 */
  export default {
    name: 'ModalButtons',
    components: {},
    props: {
      // 按钮相关
      needButton: {
        type: Boolean,
        default: true
      },
      buttonPosition: {
        type: String,
        validator: function (value) {
          return ['center', 'right'].includes(value)
        },
        default: 'right'
      },
      okText: {
        type: String,
        default: '确定'
      },
      okClass: {
        type: String,
        default: 'btn-fill-34'
      },
      okLoading: {
        type: Boolean,
        default: false
      },
      okDisabled: {
        type: Boolean,
        default: false
      },
      okShow: {
        type: Boolean,
        default: true
      },
      cancelText: {
        type: String,
        default: '取消'
      },
      cancelClass: {
        type: String,
        default: 'btn-border-34'
      },
      cancelLoading: {
        type: Boolean,
        default: false
      },
      cancelDisabled: {
        type: Boolean,
        default: false
      },
      cancelShow: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {}
    },
    mounted () {},
    methods: {
      onCancel () {
        this.$emit('on-cancel')
      },
      onOk () {
        this.$emit('on-ok')
      }
    },
    computed: {
      buttonPositionClass () {
        return `button-${this.buttonPosition}`
      }
    },
    watch: {}
  }
</script>

<style lang="less" scoped>
  @import "../../../styles/_common/components/index.less";

  .buttons {
    width: 100%;
    margin-top: 20px;
  }
  .button {
    &-center {
      display: flex;
      justify-content: center;
      align-items: center;
      Button+Button {
        margin-left: 32px;
      }
    }
    &-right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/modal-custom/modal-buttons.vue